
import $ from "dabbyjs/src/core/dabby/dabby.js";
import mfa from "../mfa/javascript/mfa.js";
import accountmenu from "./account-menu.js";

export default () => {
	accountmenu($("#account-select"));
	mfa();
};